import { ProductStockStatus } from '@/constants'
import useCurrencyNumber from '@/hooks/useCurrencyNumber'

interface ProductPrice {
  originPrice?: number
  finalPrice?: number
  className?: string
  stockStatus: ProductStockStatus
}

const ProductPrice = ({
  originPrice = 0,
  finalPrice = 0,
  className,
  stockStatus,
}: ProductPrice) => {
  const format = useCurrencyNumber()
  const percent = ((originPrice - finalPrice) / originPrice) * 100
  return (
    <div className={className}>
      <div className='flex h-[1em] items-center text-sm'>
        {!!percent && (
          <span className='text-sub line-through'>
            {format(originPrice, true)}
          </span>
        )}
        {!!percent && (
          <span className='ml-1 inline-block h-[17px] rounded bg-secondary-20 px-1 font-semibold text-secondary'>
            -{percent?.toFixed(0)}%
          </span>
        )}
      </div>
      <span className='mt-1 block text-xl font-semibold text-secondary'>
        {format(finalPrice)}{' '}
        {stockStatus === ProductStockStatus.OUT_OF_STOCK && (
          <span className='text-danger ml-2 inline-block rounded-md border border-red-1100 p-0.5 text-[10px] font-normal leading-none'>
            Hết hàng
          </span>
        )}
      </span>
    </div>
  )
}

export default ProductPrice
